// German translations
export const de = {
  brandName: "VAROTRADES Inc",
  login: "Anmelden",
  register: "Registrieren",
  logout: "Abmelden",
  dashboard: "Dashboard",
  settings: "Einstellungen",
  adminPanel: "Admin-Panel",
  search: "Suchen",
  viewAll: "Alle Anzeigen",
  learnMore: "Mehr Erfahren",
  getStarted: "Jetzt Starten",
  downloadApp: "App Herunterladen",
  
  nav: {
    trade: "Handeln",
    markets: "Märkte",
    earn: "Verdienen",
    learn: "Lernen",
    more: "Mehr",
    spotTrading: "Spot-Handel",
    spotTradingDesc: "Kaufe und verkaufe über 2.000 Kryptowährungen",
    futures: "Futures",
    futuresDesc: "Handle mit bis zu 125x Hebel",
    marginTrading: "Margin-Handel",
    marginTradingDesc: "Verstärke deine Handelskraft",
    copyTrading: "Copy Trading",
    copyTradingDesc: "Folge Top-Händlern automatisch",
    tradingBots: "Trading Bots",
    tradingBotsDesc: "Automatisiere deine Strategien 24/7",
    p2pTrading: "P2P-Handel",
    p2pTradingDesc: "Handle direkt mit anderen",
    marketOverview: "Marktübersicht",
    marketOverviewDesc: "Alle Märkte und Preise",
    cryptocurrencies: "Kryptowährungen",
    cryptocurrenciesDesc: "BTC, ETH und über 2000 mehr",
    newListings: "Neue Listings",
    newListingsDesc: "Neueste Token-Ergänzungen",
    topGainers: "Top-Gewinner",
    topGainersDesc: "Beste Performer heute",
    simpleEarn: "Simple Earn",
    simpleEarnDesc: "Flexible Ersparnisse bis zu 12% APY",
    staking: "Staking",
    stakingDesc: "Sperren und Belohnungen verdienen",
    launchpool: "Launchpool",
    launchpoolDesc: "Neue Token farmen",
    hodlerAirdrops: "HODLer Airdrops",
    hodlerAirdropsDesc: "Belohnungen für Halter",
    cryptoAcademy: "Krypto-Akademie",
    cryptoAcademyDesc: "Kurse für alle Niveaus",
    videoTutorials: "Video-Tutorials",
    videoTutorialsDesc: "Schritt-für-Schritt-Anleitungen",
    articlesGuides: "Artikel & Leitfäden",
    articlesGuidesDesc: "Tiefgehendes Wissen",
    helpCenter: "Hilfezentrum",
    helpCenterDesc: "FAQs und Support",
    aboutUs: "Über Uns",
    aboutUsDesc: "Unsere Geschichte und Mission",
    security: "Sicherheit",
    securityDesc: "Wie wir dich schützen",
    proofOfReserves: "Reservenachweis",
    proofOfReservesDesc: "100% Transparenz",
    careers: "Karriere",
    careersDesc: "Tritt unserem Team bei",
  },
  
  hero: {
    title1: "Dein Tor zur Welt der",
    title2: "Kryptowährungen",
    subtitle: "Vertraut von über",
    traders: "49 Millionen",
    tradersText: "Händlern weltweit",
    continueWith: "Oder fortfahren mit",
  },
  
  stats: {
    volume24h: "24h Handelsvolumen",
    cryptocurrencies: "Kryptowährungen",
    simpleEarnApy: "Simple Earn APY",
    reserveRatio: "Reservequote",
  },
  
  products: {
    title: "Handle Jederzeit und Überall",
    subtitle: "Vielfältige Produkte für alle Handelsstrategien",
    spotTrading: "Spot-Handel",
    spotDesc: "Über 2000 Paare",
    futures: "Futures",
    futuresDesc: "Bis zu 125x Hebel",
    copyTrading: "Copy Trading",
    copyDesc: "Folge Experten",
    tradingBots: "Trading Bots",
    botsDesc: "24/7 automatisiert",
    simpleEarn: "Simple Earn",
    earnDesc: "Flexible Renditen",
    launchpool: "Launchpool",
    launchDesc: "Neue Token",
    popular: "Beliebt",
    hot: "Heiß",
    easy: "Einfach",
    smart: "Intelligent",
    earn: "Verdienen",
    exclusive: "Exklusiv",
  },
  
  howToStart: {
    title: "Wie Man Beginnt",
    step1Title: "Konto Erstellen",
    step1Desc: "Registriere dich und erhalte exklusive Willkommensbelohnungen",
    step2Title: "Schnellkauf",
    step2Desc: "Kaufe Krypto in einfachen Schritten",
    step3Title: "Mit dem Handeln Beginnen",
    step3Desc: "Handle, kopiere Trades und verdiene mehr",
    welcomeBonus: "Willkommensbonus",
    forNewUsers: "Für neue Nutzer",
  },
  
  security: {
    title: "Wir Schützen Jeden Trade",
    subtitle: "Mehrschichtige Sicherheit zum Schutz deiner Assets",
    advancedSecurity: "Fortschrittliche Sicherheit",
    advancedSecurityDesc: "Geprüfte Smart Contracts und On-Chain-Überwachung verhindern Schwachstellen",
    proofOfReserves: "Reservenachweis",
    proofOfReservesDesc: "Erste Plattform mit 100% Reserven und transparenten Audits",
    secureStorage: "Sichere Aufbewahrung",
    secureStorageDesc: "Strategische Cold-Wallet-Speicherung zum Schutz deiner Assets",
  },
  
  cta: {
    title: "Beginne Deine Reise Heute",
    subtitle: "Schließe dich Millionen von Händlern weltweit an und genieße ein sicheres Handelserlebnis",
    createAccount: "Kostenloses Konto Erstellen",
    exploreMarkets: "Märkte Erkunden",
  },
  
  footer: {
    products: "Produkte",
    services: "Dienstleistungen",
    support: "Support",
    company: "Unternehmen",
    legal: "Rechtliches",
    description: "Eine vertrauenswürdige globale Handelsplattform für Millionen von Nutzern. Sicher und transparent handeln.",
    downloadApp: "App Herunterladen",
    sslEncrypted: "SSL-Verschlüsselt",
    reserves: "Reserven",
    securityAudited: "Sicherheitsgeprüft",
    allRightsReserved: "Alle Rechte vorbehalten",
    riskWarning: "Risikowarnung: Der Handel mit Kryptowährungen birgt hohe Risiken. Verstehe die Risiken vor dem Handeln.",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzrichtlinie",
    riskDisclosure: "Risikooffenlegung",
    amlPolicy: "AML-Richtlinie",
    helpCenter: "Hilfezentrum",
    faq: "FAQ",
    fees: "Gebühren",
    apiDocs: "API-Dokumentation",
    submitRequest: "Anfrage Senden",
    aboutVAROTRADES: "Über VAROTRADES",
    news: "Nachrichten",
    partnerships: "Partnerschaften",
    buyCrypto: "Krypto Kaufen",
  },
  
  promo: {
    signUpNow: "Melde dich jetzt an und erhalte bis zu",
    upTo: "",
    inRewards: "an Belohnungen",
  },
  
  priceCard: {
    hot: "Heiß",
    new: "Neu",
    gainers: "Gewinner",
  },
  
  partners: {
    officialPartner: "Offizieller Partner:",
  },
  
  loginPage: {
    title: "Anmelden",
    welcome: "Willkommen zurück bei VAROTRADES",
    email: "E-Mail",
    password: "Passwort",
    forgotPassword: "Passwort vergessen?",
    loggingIn: "Anmeldung...",
    continueWith: "Oder fortfahren mit",
    noAccount: "Noch kein Konto?",
    registerNow: "Jetzt Registrieren",
    demoAccount: "Demo-Konto:",
    invalidCredentials: "Ungültige E-Mail oder Passwort",
    twoFactorTitle: "Zwei-Faktor-Authentifizierung",
    twoFactorDesc: "Gib den Code aus deiner Authenticator-App ein",
    verify: "Verifizieren",
    goBack: "Zurück",
    invalidCode: "Ungültiger Verifizierungscode",
  },
  
  registerPage: {
    title: "Konto Erstellen",
    subtitle: "Tritt VAROTRADES noch heute bei",
    welcomeBonus: "$100 Willkommensbonus",
    bonusDesc: "Registriere dich jetzt und sichere dir deinen Bonus",
    firstName: "Vorname",
    lastName: "Nachname",
    confirmPassword: "Passwort Bestätigen",
    agreeToTerms: "Ich stimme den",
    termsOfService: "Nutzungsbedingungen",
    and: "und",
    privacyPolicy: "Datenschutzrichtlinie",
    creatingAccount: "Konto wird erstellt...",
    createAccount: "Konto Erstellen",
    registerWith: "Oder registrieren mit",
    haveAccount: "Bereits ein Konto?",
    mustAgree: "Du musst den Nutzungsbedingungen zustimmen",
    passwordMismatch: "Passwörter stimmen nicht überein",
    passwordLength: "Passwort muss mindestens 6 Zeichen haben",
    accountFailed: "Konteerstellung fehlgeschlagen",
  },
  
  marketsPage: {
    title: "Märkte",
    subtitle: "Verfolge Preise, Marktkapitalisierungen und Handelsvolumen",
    totalMarketCap: "Gesamte Marktkapitalisierung",
    volume24h: "24h Volumen",
    btcDominance: "BTC-Dominanz",
    activeCryptos: "Aktive Kryptos",
    all: "Alle",
    hot: "Heiß",
    newListings: "Neue Listings",
    topGainers: "Top-Gewinner",
    topLosers: "Top-Verlierer",
    searchCoins: "Coins suchen...",
    filter: "Filtern",
    name: "Name",
    price: "Preis",
    change24h: "24h Änderung",
    volume: "24h Volumen",
    action: "Aktion",
    trade: "Handeln",
    loadMore: "Mehr Laden",
    readyToTrade: "Bereit zum Handeln?",
    joinMillions: "Schließe dich Millionen von Händlern an und starte deine Krypto-Reise",
  },
  
  learnPage: {
    title: "Lerne",
    titleHighlight: "Krypto",
    titleEnd: "Trading",
    subtitle: "Kostenlose Kurse, Tutorials und Leitfäden zum Meistern des Kryptowährungshandels",
    searchPlaceholder: "Kurse, Artikel, Videos suchen...",
    all: "Alle",
    beginner: "Anfänger",
    trading: "Trading",
    security: "Sicherheit",
    defi: "DeFi",
    featuredCourses: "Empfohlene Kurse",
    viewAll: "Alle Anzeigen",
    videoTutorials: "Video-Tutorials",
    articlesGuides: "Artikel & Leitfäden",
    faq: "Häufig Gestellte Fragen",
    faqSubtitle: "Schnelle Antworten auf häufige Fragen",
    viewAllFaqs: "Alle FAQs Anzeigen",
    readyToPractice: "Bereit, dein Wissen Anzuwenden?",
    startTradingConfidence: "Beginne mit dem Handeln mit dem, was du gelernt hast",
    startTradingNow: "Jetzt mit dem Handeln Beginnen",
    lessons: "Lektionen",
    views: "Aufrufe",
    minRead: "Min. Lesezeit",
  },
  
  companyPage: {
    title: "Über",
    titleHighlight: "VAROTRADES",
    subtitle: "Wir bauen die Zukunft der Finanzen, indem wir Kryptowährungen zugänglich, sicher und einfach für alle machen.",
    registeredUsers: "Registrierte Nutzer",
    countriesServed: "Bediente Länder",
    dailyVolume: "Tägliches Handelsvolumen",
    cryptocurrencies: "Kryptowährungen",
    ourStory: "Unsere Geschichte",
    ourStoryP1: "VAROTRADES wurde 2017 mit einer einfachen Mission gegründet: Kryptowährungshandel für jeden zugänglich zu machen.",
    ourStoryP2: "Was als kleines Team leidenschaftlicher Krypto-Enthusiasten begann, ist zu einer globalen Plattform gewachsen.",
    ourStoryP3: "Heute sind wir stolz, eine der führenden Kryptowährungsbörsen der Welt zu sein.",
    ourValues: "Unsere Werte",
    ourValuesSubtitle: "Die Prinzipien, die alles leiten, was wir tun",
    securityFirst: "Sicherheit Zuerst",
    securityFirstDesc: "Wir priorisieren die Sicherheit der Assets unserer Nutzer.",
    userCentric: "Nutzerorientiert",
    userCentricDesc: "Jede Entscheidung wird von dem geleitet, was für unsere Nutzer am besten ist.",
    innovation: "Innovation",
    innovationDesc: "Wir überschreiten ständig Grenzen für modernste Handelslösungen.",
    globalAccess: "Globaler Zugang",
    globalAccessDesc: "Kryptowährungen für jeden, überall zugänglich machen.",
    securityTrust: "Sicherheit & Vertrauen",
    securityTrustSubtitle: "Deine Sicherheit ist unsere höchste Priorität",
    proofOfReserves: "Reservenachweis",
    proofOfReservesDesc: "100% der Nutzer-Assets sind gesichert und on-chain verifizierbar.",
    coldStorage: "Cold Storage",
    coldStorageDesc: "Mehrheit der Assets in sicheren, offline Cold Wallets gespeichert.",
    regularAudits: "Regelmäßige Audits",
    regularAuditsDesc: "Drittanbieter-Sicherheitsaudits gewährleisten höchste Standards.",
    insuranceFund: "Versicherungsfonds",
    insuranceFundDesc: "Ein dedizierter Fonds zum Schutz der Nutzer.",
    leadershipTeam: "Führungsteam",
    leadershipSubtitle: "Lerne die Menschen kennen, die unsere Mission vorantreiben",
    globalPresence: "Globale Präsenz",
    globalPresenceSubtitle: "Weltweite Nutzerbetreuung mit regionalem Support",
    joinOurTeam: "Tritt Unserem Team Bei",
    joinTeamDesc: "Wir suchen immer talentierte Menschen, die unsere Leidenschaft für Kryptowährungen teilen.",
    viewOpenPositions: "Offene Stellen Anzeigen",
    teamMembers: "Teammitglieder",
    countries: "Länder",
    openRoles: "Offene Stellen",
    remoteFriendly: "Remote-Freundlich",
    getInTouch: "Kontaktiere Uns",
    getInTouchSubtitle: "Hast du Fragen? Wir sind hier, um zu helfen",
    emailUs: "Schreib Uns",
  },
  
  chat: {
    title: "VAROTRADES Assistent",
    online: "Online",
    welcomeMessage: "Hallo! 👋 Ich bin dein VAROTRADES KI-Assistent.\n\nWie kann ich dir heute helfen?",
    placeholder: "Schreibe deine Nachricht...",
    poweredBy: "Powered by KI",
    instantSupport: "24/7 Sofort-Support",
    newChat: "Neuer Chat",
    errorMessage: "Entschuldigung, ein Fehler ist aufgetreten. Bitte versuche es erneut.",
    connectionError: "Entschuldigung, Verbindungsfehler. Bitte versuche es später erneut.",
    quickQuestion1: "Wie fange ich mit dem Handeln an?",
    quickQuestion2: "Was sind die Gebühren?",
    quickQuestion3: "Wie zahle ich ein?",
    quickQuestion4: "Ist die Plattform sicher?",
  },
  
  languages: {
    ar: "العربية",
    en: "English",
    es: "Español",
    de: "Deutsch",
    zh: "中文",
    ja: "日本語",
    he: "עברית",
  },
};

export default de;
